// extracted by mini-css-extract-plugin
module.exports = {"container":"testCard_container__2OxA6","title":"testCard_title__ctpOq","description":"testCard_description__3M5j9"};